function unpaidPopupShowsNotify(mode) {
  return mode === 'rent' || mode === 'balance';
}

module.exports = {
  unpaidPopupShowsNotify,
};
